// extracted by mini-css-extract-plugin
export default {"App":"Login_App__qJ2cf","ContentWrapper":"Login_ContentWrapper__jDjMi","FormWrapper":"Login_FormWrapper__azJdM","Message":"Login_Message__QzoT3","FormTitle":"Login_FormTitle__J6ySz"};